import { useQuery } from "@apollo/client";
import {
  OrganizationEditQuery,
  OrganizationShowQuery,
  OrganizationBillingRequisitesQuery,
} from "../graphql/queries";
import type {
  OrganizationBillingRequisitesQueryType,
  OrganizationBillingRequisitesQueryVariablesType,
} from "@/types/graphql/admin.generated";

/**
 * Хук для загрузки одной организации (для просмотра)
 */
export function useOrganizationShowQuery(id: string | null, skip = false) {
  return useQuery(OrganizationShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

/**
 * Хук для загрузки организации для редактирования
 */
export function useOrganizationEditQuery(id: string | null, skip = false) {
  return useQuery(OrganizationEditQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

/**
 * Хук для загрузки реквизитов плательщика организации (вкладка «Реквизиты»)
 */
export function useOrganizationBillingRequisitesQuery(
  id: string | null,
  skip = false
) {
  return useQuery<
    OrganizationBillingRequisitesQueryType,
    OrganizationBillingRequisitesQueryVariablesType
  >(OrganizationBillingRequisitesQuery, {
    variables: { id: id as string },
    skip: skip || !id,
  });
}
